function setEndOfDayBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(23);
    modDate.setMinutes(59);
    modDate.setSeconds(59);
    modDate.setMilliseconds(999);

    return modDate.toISOString().replace('Z', '');
}

function setStartOfDayToBackendString(date: Date | null): string | null {
    if (!date) {
        return null;
    }

    const modDate = new Date(date);

    modDate.setHours(0);
    modDate.setMinutes(0);
    modDate.setSeconds(0);
    modDate.setMilliseconds(0);

    return modDate.toISOString().replace('Z', '');
}

function formatDateUtc(value: string | Date | null | undefined): string {
    if (value == null) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    const h = String(d.getUTCHours()).padStart(2, '0');
    const min = String(d.getUTCMinutes()).padStart(2, '0');
    const s = String(d.getUTCSeconds()).padStart(2, '0');
    return `${y}-${m}-${day} ${h}:${min}:${s} UTC`;
}

export const DateHelper = {
    setEndOfDayBackendString,
    setStartOfDayToBackendString,
    formatDateUtc,
};
